import React from "react";
import { messages } from "../../../../config/constants";
import { FineGrainedPermission, Permission } from "../../../../types/permissions";
import { Role } from "../../../../types/roles";
import { UserClaims } from "../../../../types/users";
import DismissibleMessage from "../../../common/DismissibleMesage";
import MyPermissions from "./MyPermissions";
import RoleComponent from "./Role";

type RolesPermissionsProps = {
  user: UserClaims | Record<string, never>;
  permissions: Permission[];
  fineGrainedPermissions: FineGrainedPermission[];
  roles: Role[];
  onChange: (change: any) => any;
  canEdit: boolean;
  administrators: string[];
  isExternal: boolean;
  regionDB?: string;
};

class RolesPermissions extends React.PureComponent<RolesPermissionsProps> {
  render() {
    const filteredRoles = this.props.roles.filter(role => !role.code.includes("ADMIN"));
    return this.props.canEdit ? (
      <>
        {this.props.isExternal && (
          <DismissibleMessage
            className={messages.hasExternalSubscription.className}
            content={messages.hasExternalSubscription.content}
          />
        )}
        <div style={{ display: "flex", alignItems: "flex-start" }} className="role-details-wrapper">
          {filteredRoles.map(role => (
            <RoleComponent
              regionDB={this.props.regionDB}
              canEdit={this.props.canEdit}
              key={role.id}
              role={role}
              permissions={this.props.permissions}
              fineGrainedPermissions={this.props.fineGrainedPermissions}
              onChange={this.props.onChange}
            />
          ))}
        </div>
      </>
    ) : (
      <>
        {this.props.isExternal && (
          <DismissibleMessage
            className={messages.hasExternalSubscription.className}
            content={messages.hasExternalSubscription.content}
          />
        )}
        <MyPermissions
          administrators={this.props.administrators}
          permissions={this.props.permissions}
          fineGrainedPermissions={this.props.fineGrainedPermissions}
          role={
            this.props.roles.find(
              role => role.id === (this.props.user.selectedRoles ?? [])[0]?.id
            ) || {}
          }
        />
      </>
    );
  }
}

export default RolesPermissions;
